import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";
import {convertPersianDateToUniversalDate, convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";

export class LoanRequestService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getLoanRequestsList(page, fullName, filterStartDate, filterEndDate, accountNumber, size = 15) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/loans/requests`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page,
                    size,
                    "full-name": fullName,
                    "start-send-at": filterStartDate,
                    "end-send-at": filterEndDate,
                    "deposit-account-number": accountNumber,
                }
            ).then(resolve).catch(reject)
        })
    }

    getLoanRequestDetail(requestId) {

        const loanRequestDetail = this.httpClient.get(
            `fund-presentation/funds/${this.fundID}/loans/requests/${requestId}`,
            this.httpClient.prepareUserAccessHeader(this.token)
        )

        const loanRequestInstallmentsDetail = this.httpClient.get(
            `fund-presentation/funds/${this.fundID}/loans/requests/${requestId}/pre-create`,
            this.httpClient.prepareUserAccessHeader(this.token)
        )

        const loanRequestOffers = this.httpClient.get(
            `fund-presentation/funds/${this.fundID}/loan-requests/${requestId}/loans/offers`,
            this.httpClient.prepareUserAccessHeader(this.token)
        )


        return new Promise((resolve, reject) => {
            axios.all([loanRequestDetail, loanRequestInstallmentsDetail, loanRequestOffers]).then(resolve).catch(reject)
        })
    }

    rejectLoanRequest(requestId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `fund-presentation/funds/${this.fundID}/loans/requests/${requestId}/rejected`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    acceptLoanRequest(requestId, submitLoanKinds, submitDate, submitAmount, submitInstallmentNumber) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `fund-presentation/funds/${this.fundID}/loans/requests/${requestId}/accepted`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    "acceptedAmount": submitAmount,
                    "acceptedNumberOfInstallments": submitInstallmentNumber,
                    "acceptedLoanKindId": submitLoanKinds,
                    "grantDate": convertPersianDateToUniversalDate(submitDate)
                }
            ).then(resolve).catch(reject)
        })
    }

    getPendingLoanRequestTotalAmount() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/loans/requests/statistics`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }
}